import React from 'react';

const renderWithBoldCaps = (text) => {
  const parts = text.split(/([A-Z]{2,}\*?)/g);
  return parts.map((part, i) =>
    /^[A-Z]{2,}\*?$/.test(part) ? <strong key={i}>{part}</strong> : part
  );
};

const renderInlineFollowUp = (fu, allAnswers, onChange) => {
  if (fu.fields) {
    return (
      <div style={{ marginTop: '16px' }}>
        {fu.fields.map(f => (
          <div key={f.id} style={{ marginBottom: '12px' }}>
            <div className="input-label">{f.label}</div>
            {f.type === 'date'
              ? <input className="text-input date-input" type="date" value={allAnswers[f.id] || ''} onChange={e => onChange(e.target.value, f.id)} />
              : f.type === 'textarea'
              ? <textarea className="text-input" placeholder={f.placeholder || ''} value={allAnswers[f.id] || ''} onChange={e => onChange(e.target.value, f.id)} rows={3} maxLength={f.maxLength} />
              : <input className="text-input" placeholder={f.placeholder || ''} value={allAnswers[f.id] || ''} onChange={e => onChange(e.target.value, f.id)} maxLength={f.maxLength} />
            }
          </div>
        ))}
      </div>
    );
  }
  const fuVal = allAnswers[fu.id] || '';
  return (
    <div style={{ marginTop: '16px' }}>
      {fu.label && <div className="input-label">{fu.label}</div>}
      {fu.type === 'text'
        ? <input className="text-input" placeholder={fu.placeholder || ''} value={fuVal} onChange={e => onChange(e.target.value, fu.id)} maxLength={fu.maxLength} />
        : fu.type === 'date'
        ? <input className="text-input date-input" type="date" value={fuVal} onChange={e => onChange(e.target.value, fu.id)} />
        : fu.type === 'textarea'
        ? <textarea className="text-input" placeholder={fu.placeholder || ''} value={fuVal} onChange={e => onChange(e.target.value, fu.id)} rows={3} maxLength={fu.maxLength} />
        : null
      }
    </div>
  );
};

export default function QuestionRenderer({ question, value, onChange, onSetAll, allAnswers, onNext, globalSig, globalName }) {
  if (question.type === 'yndk-batch') {
    return (
      <div className="yndk-batch-table">
        <div className="yndk-batch-no-all-row">
          <div />
          <div />
          <div className="yndk-batch-opt-col">
            <button className="yndk-batch-no-all-btn" onClick={() => { if (window.confirm('Set all answers on this page to No?')) onSetAll(Object.fromEntries(question.items.map(item => [item.id, 'No']))); }}>
              No to All
            </button>
          </div>
          <div />
        </div>
        <div className="yndk-batch-header">
          <div className="yndk-batch-q-col">Question</div>
          <div className="yndk-batch-opt-col">Yes</div>
          <div className="yndk-batch-opt-col">No</div>
          <div className="yndk-batch-opt-col">DK</div>
        </div>
        {question.items.map(item => {
          const val = allAnswers[item.id];
          const fu = item.followUp;
          const fuVal = fu ? allAnswers[fu.id] : null;
          return (
            <React.Fragment key={item.id}>
              <div className="yndk-batch-row">
                <div className="yndk-batch-q-col">{item.label}</div>
                {['Yes', 'No', "Don't Know"].map(opt => (
                  <div key={opt} className="yndk-batch-opt-col">
                    <button
                      className={`yndk-batch-btn${val === opt ? ' selected ' + (opt === 'Yes' ? 'yes' : opt === 'No' ? 'no' : 'dk') : ''}`}
                      onClick={() => onChange(val === opt ? '' : opt, item.id)}
                    />
                  </div>
                ))}
              </div>
              {fu && val === fu.showIf && (
                <div className="yndk-batch-followup-row">
                  {fu.fields
                    ? fu.fields.map(f => (
                        <div key={f.id} className="yndk-batch-followup-field">
                          <span className="yndk-batch-followup-label">{f.label}</span>
                          <input className="text-input" placeholder={f.placeholder || ''} value={allAnswers[f.id] || ''} onChange={e => onChange(e.target.value, f.id)} />
                        </div>
                      ))
                    : <>
                        <span className="yndk-batch-followup-label">{fu.label}</span>
                        {fu.type === 'text'
                          ? <input className="text-input" placeholder={fu.placeholder || ''} value={fuVal || ''} onChange={e => onChange(e.target.value, fu.id)} />
                          : fu.type === 'date'
                          ? <input className="text-input date-input" type="date" value={fuVal || ''} onChange={e => onChange(e.target.value, fu.id)} />
                          : <div className="yndk-batch-followup-options">
                              {fu.options.map(opt => (
                                <button key={opt}
                                  className={`yndk-batch-followup-btn${fuVal === opt ? ' selected' : ''}`}
                                  onClick={() => onChange(fuVal === opt ? '' : opt, fu.id)}>
                                  {opt}
                                </button>
                              ))}
                            </div>
                        }
                      </>
                  }
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  if (question.type === 'yndk') {
    return (
      <div>
        <div className="yndk-group">
          {["Yes", "No", "Don't Know"].map(opt => (
            <button key={opt}
              className={`yndk-btn ${value === opt ? 'selected ' : ''} ${value === opt ? (opt === 'Yes' ? 'yes' : opt === 'No' ? 'no' : 'dk') : ''}`}
              onClick={() => onChange(value === opt ? '' : opt)}>
              {opt}
            </button>
          ))}
        </div>
        {question.followUp && value === question.followUp.showIf && renderInlineFollowUp(question.followUp, allAnswers, onChange)}
      </div>
    );
  }

  if (question.type === 'text') {
    return <input className="text-input" placeholder={question.placeholder || ''} value={value || ''} onChange={e => onChange(e.target.value)} maxLength={question.maxLength} />;
  }

  if (question.type === 'textarea') {
    return <textarea className="text-input" placeholder={question.placeholder || ''} value={value || ''} onChange={e => onChange(e.target.value)} rows={4} maxLength={question.maxLength} />;
  }

  if (question.type === 'date') {
    return (
      <div>
        <input className="text-input date-input" type="date" value={value || ''} onChange={e => onChange(e.target.value)} />
        {question.followUp && !!value && renderInlineFollowUp(question.followUp, allAnswers, onChange)}
      </div>
    );
  }

  if (question.type === 'radio') {
    return (
      <div className="radio-group">
        {question.options.map(opt => (
          <div key={opt} className={`radio-item ${value === opt ? 'selected' : ''}`} onClick={() => onChange(opt)}>
            <div className="radio-dot" />
            <span>{opt}</span>
          </div>
        ))}
        {question.followUp && value === question.followUp.triggerValue && (
          question.followUp.fields
            ? renderInlineFollowUp(question.followUp, allAnswers, onChange)
            : <textarea className="text-input" style={{ marginTop: '12px' }}
                placeholder={question.followUp.field.placeholder || ''}
                value={allAnswers[question.followUp.field.id] || ''}
                onChange={e => onChange(e.target.value, question.followUp.field.id)}
                rows={3} maxLength={question.followUp.field.maxLength} />
        )}
      </div>
    );
  }

  if (question.type === 'checkbox-multi') {
    const vals = value ? value.split('||') : [];
    return (
      <div className="checkbox-group">
        {question.options.map(opt => {
          const checked = vals.includes(opt);
          const subFields = question.optionFields && question.optionFields[opt];
          const groupLabel = question.groupLabels && question.groupLabels[opt];
          const initialsId = question.optionInitials && question.optionInitials[opt];
          return (
            <div key={opt}>
              {groupLabel && <div className="checkbox-group-label">{groupLabel}</div>}
              {initialsId ? (
                <div className="initials-item">
                  <input className="initials-input" placeholder="Init." value={allAnswers[initialsId] || ''}
                    maxLength={5} onChange={e => onChange(e.target.value, initialsId)} />
                  <span className="initials-label">{opt}</span>
                </div>
              ) : (
              <div className={`checkbox-item ${checked ? 'checked' : ''}`}
                onClick={() => {
                  const next = checked ? vals.filter(v => v !== opt) : [...vals, opt];
                  onChange(next.join('||'));
                }}>
                <div className="checkbox-box">{checked ? '✓' : ''}</div>
                <span className="checkbox-label">{opt}</span>
              </div>
              )}
              {checked && subFields && (
                <div className="checkbox-subfields" onClick={e => e.stopPropagation()}>
                  {subFields.map(f => (
                    <div key={f.id}>
                      <div className="input-label">{f.label}</div>
                      <input className={`text-input${f.type === 'date' ? ' date-input' : ''}`} type={f.type === 'date' ? 'date' : 'text'}
                        placeholder={f.placeholder || ''} value={allAnswers[f.id] || ''}
                        onChange={e => onChange(e.target.value, f.id)}
                        maxLength={f.maxLength} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  if (question.type === 'multi-text') {
    const rowFields = question.fields.filter(f => !f.solo);
    const soloFields = question.fields.filter(f => f.solo);
    const renderField = (f) => {
      const fieldVal = allAnswers[f.id] || '';
      return (
        <div key={f.id}>
          {question.questionStyleLabels
            ? <div className="question-text" style={{ fontSize: '20px', marginBottom: '8px' }}>{f.label}</div>
            : <div className="input-label">{f.label}</div>}
          <input className="text-input" placeholder={f.placeholder || ''} value={fieldVal}
            onChange={e => onChange(e.target.value, f.id)} maxLength={f.maxLength} />
        </div>
      );
    };
    const rowBlock = (
      <div className={`input-row ${rowFields.length === 3 ? 'three' : ''}`}
        style={question.columns ? { gridTemplateColumns: question.columns } : {}}>
        {rowFields.map(renderField)}
      </div>
    );
    const soloBlock = soloFields.map(f => <div key={f.id} style={{ marginTop: '16px' }}>{renderField(f)}</div>);
    return (
      <div>
        {question.soloFirst ? soloBlock : rowBlock}
        {question.soloFirst
          ? <div style={{ marginTop: '16px' }}>{rowBlock}</div>
          : soloBlock}
      </div>
    );
  }

  if (question.type === 'consent') {
    return (
      <div>
        <div className="consent-block">
          {question.text.split('\n\n').map((para, i) => <p key={i}>{renderWithBoldCaps(para)}</p>)}
        </div>
        {!question.noButton && (
          <button className="understand-btn" onClick={() => { onChange('acknowledged'); onNext(); }}>
            ✓ &nbsp; I Understand and Agree
          </button>
        )}
      </div>
    );
  }

  if (question.type === 'signature') {
    const isSig = value && value.startsWith('drawn:');
    const isName = value && value.startsWith('typed:');
    return (
      <div>
        {question.notice && (
          <div className="question-notice">
            {question.notice.split('\n\n').map((para, i) => <p key={i}>{para}</p>)}
          </div>
        )}
        <div className="sig-tabs">
          <button className={`sig-tab ${isSig ? 'active' : ''}`} onClick={() => onChange(globalSig)}>✍️ Use Signature</button>
          <button className={`sig-tab ${isName ? 'active' : ''}`} onClick={() => onChange('typed:' + globalName)}>⌨️ Use Printed Name</button>
        </div>
        <div className="sig-canvas-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80px', padding: '12px' }}>
          {isSig
            ? <img src={value.slice(6)} alt="signature" style={{ maxHeight: '120px', maxWidth: '100%' }} />
            : isName
              ? <span className="sig-type-input">{value.slice(6)}</span>
              : null}
        </div>
        {question.dateField && (
          <div style={{ marginTop: '16px' }}>
            <div className="input-label">{question.dateField.label}</div>
            <input className="text-input date-input" type="date"
              value={allAnswers[question.dateField.id] || ''}
              onChange={e => onChange(e.target.value, question.dateField.id)} />
          </div>
        )}
        {question.footnote && (
          <p style={{ marginTop: '16px', fontWeight: '700', fontSize: '18px', lineHeight: '1.5', color: 'var(--text-secondary)' }}>{question.footnote}</p>
        )}
      </div>
    );
  }

  return null;
}
